import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Card,
  Col,
  Container,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import Button from "../../Components/Buttons/Button";
import { emailRegister } from "../../services/emailRegister";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";
import "../../Components/Popup/Popup.scss";

const Register = () => {
  const { referral } = useParams();
  const navigate = useNavigate();
  const [showReferral, setShowReferral] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    referralCode: referral ? referral : "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };



  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setErrorMessage("");
    try {
      const response = await emailRegister({
        email: formData.email,
        password: formData.password,
        // countryId: formData.country,
        referralCode: formData.referralCode,
      });

      if (response.isSuccess) {
        localStorage.setItem("token", response.authToken);
        localStorage.setItem("email", formData.email);

        if (!response.billingDetails) {
          navigate("/dashboard/personal-info");
        } else {
          navigate("/dashboard/home");
        }
      } else {
        setErrorMessage(response.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      setErrorMessage("An unexpected error occurred. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const isFormValid = formData.email && formData.password;

  return (
    <>
      <Helmet>
        <title>
          Register | Get Personalized Academic Success with DoubtQ | Online
          Question Help
        </title>
        <meta name="description" content="Welcome to the Register of DoubtQ" />
        <meta property="og:title" content="Register - DoubtQ" />
        <meta
          property="og:description"
          content="Explore personalized academic help on DoubtQ's Register"
        />
      </Helmet>
      <div className="authentication-bg">
        <div className="authentication-container">
          <Card className="w-85">
            <div className="main-logo">
              <Link to="/">
                <img
                  src="/static/media/logo.2a56fbbd0d6820b49766bd07730a25b3.svg"
                  alt="logo"
                />
              </Link>
            </div>
            <Container>
              <Row className="div-r">
                <Col
                  xs={12}
                  md={4}
                  className="d-flex flex-column signInStaticData gap-5 border-end justify-content-center"
                >
                  <span className="d-flex flex-column text-center align-items-center">
                    <span className="authentication-card-sidebar-title">
                      Get One Step Closer To{" "}
                    </span>
                    <b>Your A+ Grade</b>
                  </span>
                  <Row className="justify-content-center">
                    <Col xs={12} className="d-flex justify-content-center">
                      <span className="d-flex flex-column gap-4 text-start">
                        <span className="d-flex gap-4 align-items-center">
                          <span className="authentication-card-sidebar-icon">
                            <svg
                              width="44"
                              height="37"
                              viewBox="0 0 44 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.61298 41.1537C10.0378 41.1537 10.3822 40.8093 10.3822 40.3845C10.3822 39.9596 10.0378 39.6152 9.61298 39.6152C9.18815 39.6152 8.84375 39.9596 8.84375 40.3845C8.84375 40.8093 9.18815 41.1537 9.61298 41.1537Z"
                                fill="#E9DFFC"
                              />
                              <path
                                d="M15.7722 16.9234C16.3808 16.9234 16.9757 16.7429 17.4817 16.4048C17.9877 16.0667 18.3821 15.5862 18.6149 15.0239C18.8478 14.4617 18.9088 13.843 18.79 13.2462C18.6713 12.6493 18.3783 12.1011 17.9479 11.6707C17.5176 11.2404 16.9694 10.9474 16.3725 10.8287C15.7756 10.7099 15.157 10.7709 14.5947 11.0037C14.0325 11.2366 13.552 11.631 13.2139 12.137C12.8758 12.643 12.6953 13.2379 12.6953 13.8465C12.6953 14.6625 13.0195 15.4451 13.5965 16.0222C14.1736 16.5992 14.9562 16.9234 15.7722 16.9234ZM15.7722 12.308C16.0765 12.308 16.374 12.3982 16.627 12.5673C16.88 12.7363 17.0771 12.9766 17.1936 13.2577C17.31 13.5388 17.3405 13.8482 17.2811 14.1466C17.2218 14.445 17.0752 14.7192 16.8601 14.9343C16.6449 15.1495 16.3708 15.296 16.0724 15.3554C15.7739 15.4147 15.4646 15.3843 15.1835 15.2678C14.9024 15.1514 14.6621 14.9542 14.4931 14.7012C14.324 14.4482 14.2338 14.1507 14.2338 13.8465C14.2338 13.4384 14.3959 13.0471 14.6844 12.7586C14.9729 12.4701 15.3642 12.308 15.7722 12.308Z"
                                fill="#DA21E5"
                              />
                              <path
                                d="M24.9988 20C24.3902 20 23.7953 20.1805 23.2894 20.5186C22.7834 20.8567 22.389 21.3372 22.1561 21.8994C21.9232 22.4617 21.8623 23.0803 21.981 23.6772C22.0997 24.2741 22.3928 24.8223 22.8231 25.2526C23.2534 25.683 23.8017 25.976 24.3985 26.0947C24.9954 26.2134 25.6141 26.1525 26.1763 25.9196C26.7385 25.6867 27.2191 25.2924 27.5572 24.7864C27.8953 24.2804 28.0757 23.6855 28.0757 23.0769C28.0757 22.2609 27.7515 21.4782 27.1745 20.9012C26.5975 20.3242 25.8149 20 24.9988 20ZM24.9988 24.6154C24.6945 24.6154 24.3971 24.5252 24.1441 24.3561C23.8911 24.1871 23.6939 23.9468 23.5774 23.6657C23.461 23.3845 23.4305 23.0752 23.4899 22.7768C23.5493 22.4784 23.6958 22.2042 23.9109 21.9891C24.1261 21.7739 24.4002 21.6274 24.6987 21.568C24.9971 21.5087 25.3064 21.5391 25.5875 21.6556C25.8687 21.772 26.1089 21.9692 26.278 22.2222C26.447 22.4752 26.5373 22.7726 26.5373 23.0769C26.5373 23.4849 26.3752 23.8763 26.0867 24.1648C25.7981 24.4533 25.4068 24.6154 24.9988 24.6154Z"
                                fill="#DA21E5"
                              />
                              <path
                                d="M13.3672 23.0778C13.3666 23.552 13.507 24.0157 13.7705 24.41C14.034 24.8043 14.4087 25.1114 14.8471 25.2922C15.2855 25.4731 15.7678 25.5196 16.2326 25.4258C16.6975 25.332 17.124 25.1022 17.458 24.7655L26.628 15.4793C27.056 15.044 27.2958 14.4579 27.2958 13.8474C27.2958 13.2369 27.056 12.6508 26.628 12.2155C26.1873 11.7993 25.6041 11.5674 24.998 11.5674C24.3918 11.5674 23.8086 11.7993 23.368 12.2155L14.078 21.3855C13.8534 21.6065 13.6749 21.8698 13.5529 22.1603C13.4309 22.4509 13.3677 22.7627 13.3672 23.0778ZM15.1587 22.4778L24.4533 13.3024C24.5237 13.2255 24.6089 13.1637 24.7038 13.1208C24.7987 13.0778 24.9014 13.0546 25.0056 13.0526C25.1097 13.0505 25.2132 13.0696 25.3098 13.1087C25.4064 13.1479 25.494 13.2062 25.5673 13.2802C25.6406 13.3542 25.6982 13.4424 25.7364 13.5393C25.7747 13.6362 25.7928 13.7399 25.7898 13.844C25.7868 13.9482 25.7626 14.0506 25.7188 14.1451C25.675 14.2397 25.6124 14.3243 25.5349 14.3939L16.3657 23.6839C16.2865 23.7632 16.1924 23.8261 16.0889 23.869C15.9854 23.9119 15.8745 23.934 15.7625 23.934C15.6504 23.934 15.5395 23.912 15.436 23.8692C15.3324 23.8263 15.2384 23.7635 15.1591 23.6843C15.0799 23.6051 15.017 23.5111 14.9741 23.4076C14.9312 23.3041 14.9091 23.1932 14.909 23.0811C14.909 22.9691 14.931 22.8581 14.9739 22.7546C15.0167 22.6511 15.0795 22.557 15.1587 22.4778Z"
                                fill="#E541ED"
                              />
                              <path
                                d="M34.2877 36.1669C34.4827 36.1491 34.6639 36.0589 34.7957 35.9141C34.9276 35.7693 35.0004 35.5804 35 35.3846V3.84615C34.9988 2.82647 34.5932 1.84889 33.8721 1.12786C33.1511 0.406832 32.1735 0.00122143 31.1538 0H5.76923C4.23964 0.00162896 2.77316 0.60998 1.69157 1.69157C0.60998 2.77316 0.00162896 4.23964 0 5.76923V40.3846C0.00162896 41.9142 0.60998 43.3807 1.69157 44.4623C2.77316 45.5439 4.23964 46.1522 5.76923 46.1538H34.2308C34.4364 46.1504 34.6324 46.0662 34.7763 45.9193C34.9203 45.7725 35.0006 45.5749 35 45.3692C35.0005 45.1747 34.9273 44.9872 34.7952 44.8445C34.663 44.7017 34.4817 44.6144 34.2877 44.6C33.2265 44.5164 32.2357 44.0357 31.5132 43.254C30.7906 42.4722 30.3893 41.4468 30.3893 40.3823C30.3893 39.3178 30.7906 38.2924 31.5132 37.5106C32.2357 36.7289 33.2265 36.2482 34.2877 36.1646V36.1669ZM6.53846 1.53846H31.1538C31.7659 1.53846 32.3529 1.78159 32.7856 2.21437C33.2184 2.64715 33.4615 3.23412 33.4615 3.84615V34.6154H6.53846V1.53846ZM1.53846 5.76923C1.53983 4.78091 1.88654 3.82414 2.51862 3.06438C3.15071 2.30461 4.02843 1.78962 5 1.60846V34.6731C3.67137 34.8521 2.44699 35.4895 1.53846 36.4754V5.76923ZM28.9046 39.6154H12.6923C12.4883 39.6154 12.2926 39.6964 12.1484 39.8407C12.0041 39.9849 11.9231 40.1806 11.9231 40.3846C11.9231 40.5886 12.0041 40.7843 12.1484 40.9285C12.2926 41.0728 12.4883 41.1538 12.6923 41.1538H28.9046C29.0847 42.4809 29.7198 43.7044 30.7015 44.6154H5.76923C4.64716 44.6154 3.57105 44.1696 2.77762 43.3762C1.9842 42.5828 1.53846 41.5067 1.53846 40.3846C1.53846 39.2625 1.9842 38.1864 2.77762 37.393C3.57105 36.5996 4.64716 36.1538 5.76923 36.1538H30.7015C29.7198 37.0648 29.0847 38.2883 28.9046 39.6154Z"
                                fill="#5956E9"
                              />
                            </svg>
                          </span>
                          <span className="d-flex flex-column">
                            <span className="authentication-sidebar-title">
                              <b>Step by Step Solution</b>
                            </span>
                            <span className="authentication-sidebar-description">
                              with Explanation
                            </span>
                          </span>
                        </span>
                        <span className="d-flex gap-4 align-items-center">
                          <span className="authentication-card-sidebar-icon">
                            <svg
                              width="44"
                              height="37"
                              viewBox="0 0 44 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.30146 29.4551C4.80374 29.4551 5.19839 29.0604 5.19839 28.5581V19.1762L10.6159 16.2702V23.9658C10.6159 24.4681 11.0105 24.8628 11.5128 24.8628C12.0151 24.8628 12.4097 24.4681 12.4097 23.9658V13.2744L3.42246 18.0999V28.5581C3.40452 29.0425 3.79917 29.4551 4.30146 29.4551Z"
                                fill="#5956E9"
                              />
                              <path
                                d="M15.1001 22.6565C15.6023 22.6565 15.997 22.2618 15.997 21.7596V5.90181L21.4145 2.99575V28.7915C21.4145 29.2938 21.8091 29.6884 22.3114 29.6884C22.8137 29.6884 23.2083 29.2938 23.2083 28.7915V0L14.2031 4.82549V21.7596C14.2031 22.2439 14.5978 22.6565 15.1001 22.6565Z"
                                fill="#E541ED"
                              />
                              <path
                                d="M25.903 28.5222C26.4053 28.5222 26.7999 28.1275 26.7999 27.6253V10.5297L32.2174 7.62368V23.1047C32.2174 23.607 32.612 24.0017 33.1143 24.0017C33.6166 24.0017 34.0113 23.607 34.0113 23.1047V4.62793L25.024 9.45342V27.6253C25.0061 28.1275 25.4187 28.5222 25.903 28.5222Z"
                                fill="#5956E9"
                              />
                              <path
                                d="M43.8766 21.4367C43.7151 21.1677 43.4281 20.9883 43.1052 20.9883H36.9164C36.5935 20.9883 36.3065 21.1677 36.145 21.4367C35.9836 21.7058 35.9836 22.0467 36.145 22.3337L37.2572 24.2531L32.3241 27.2489C31.5707 27.7153 30.8352 28.1637 30.0818 28.6301C29.5436 28.971 29.0054 29.2939 28.4852 29.6347C27.086 30.5316 25.8483 31.3389 24.7002 32.1282C24.1082 32.5228 23.5342 32.9354 22.9422 33.3301L14.9057 25.4729L0.41127 34.6934C-0.00131878 34.9625 -0.126889 35.5186 0.14219 35.9312C0.321577 36.2002 0.608595 36.3438 0.895613 36.3438C1.05706 36.3438 1.21851 36.2899 1.37996 36.2002L14.6545 27.7511L22.7628 35.6621L23.8571 34.8728C24.467 34.4423 25.0769 34.0117 25.7047 33.5991C26.8349 32.8278 28.0547 32.0385 29.4539 31.1415C29.9741 30.8007 30.5123 30.4778 31.0325 30.137C31.768 29.6706 32.5214 29.2221 33.2569 28.7557L37.7954 25.9752L38.1542 25.76L39.2484 27.6615C39.4099 27.9305 39.6969 28.1099 40.0198 28.1099C40.3427 28.1099 40.6297 27.9305 40.7911 27.6615L43.8945 22.2978C44.038 22.0646 44.038 21.7238 43.8766 21.4367ZM40.0018 25.455L38.4591 22.7821H41.5446L40.0018 25.455Z"
                                fill="#5956E9"
                              />
                            </svg>
                          </span>
                          <span className="d-flex flex-column">
                            <span className="authentication-sidebar-title">
                              <b>Save Time</b>
                            </span>
                            <span className="authentication-sidebar-description">
                              Never Miss Deadline
                            </span>
                          </span>
                        </span>
                        <span className="d-flex gap-4 align-items-center">
                          <span className="authentication-card-sidebar-icon">
                            <svg
                              width="44"
                              height="37"
                              viewBox="0 0 44 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15.914 31.2742C15.4513 31.7369 14.9885 32.3539 14.6801 32.9708C12.8292 31.4284 10.9783 29.7317 9.43584 27.7266C10.0528 27.4181 10.6698 26.9554 11.1325 26.4927C13.2919 24.3333 12.5207 21.5569 10.3613 19.3975C8.2019 17.2382 5.42555 16.4669 3.26616 18.6263C1.10678 20.7857 0.798292 24.796 2.49495 27.2639C5.57979 32.0454 10.3613 36.6726 15.1428 39.9117C17.7649 41.6084 21.6209 41.2999 23.7803 39.1405C25.9397 36.9811 25.1685 34.2048 23.0091 32.0454C20.8497 29.886 18.2276 29.1148 15.914 31.2742Z"
                                stroke="#6361EB"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M31.847 36.3214C38.1709 33.3908 42.6439 26.9126 42.6439 19.509C42.6439 9.32906 34.3149 1 24.1349 1C17.3483 1 11.3328 4.7018 8.09375 10.2545"
                                stroke="#E541ED"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M17.9609 14.7275L18.5779 14.1106C19.6576 13.0309 21.3543 13.0309 22.434 14.1106C23.5136 15.1902 23.5136 16.8869 22.434 17.9666L17.9609 22.5939H24.1306"
                                stroke="#5956E9"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M31.846 19.5085H27.2188L33.3884 13.3389V24.1358"
                                stroke="#5956E9"
                                strokeWidth="2"
                                strokeMiterlimit="10"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                          <span className="d-flex flex-column">
                            <span className="authentication-sidebar-title">
                              <b>100% Accuracy</b>
                            </span>
                            <span className="authentication-sidebar-description">
                              0% Plagiarism
                            </span>
                          </span>
                        </span>
                        <span className="d-flex gap-4 align-items-center">
                          <span className="authentication-card-sidebar-icon">
                            <svg
                              width="44"
                              height="37"
                              viewBox="0 0 44 37"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.78544 25.5693C3.73154 25.5693 3.67817 25.58 3.62837 25.6006C3.57857 25.6212 3.53333 25.6514 3.49521 25.6895C3.4571 25.7277 3.42687 25.7729 3.40624 25.8227C3.38562 25.8725 3.375 25.9259 3.375 25.9798V31.9158C3.375 32.0247 3.41824 32.1291 3.49521 32.2061C3.57219 32.283 3.67658 32.3263 3.78544 32.3263C3.89429 32.3263 3.99869 32.283 4.07566 32.2061C4.15263 32.1291 4.19588 32.0247 4.19588 31.9158V25.9798C4.19588 25.8709 4.15263 25.7665 4.07566 25.6895C3.99869 25.6126 3.89429 25.5693 3.78544 25.5693Z"
                                fill="#E541ED"
                                stroke="#E541ED"
                              />
                              <path
                                d="M37.59 1H1.81512C1.70626 1 1.60186 1.04324 1.52489 1.12021C1.44792 1.19719 1.40468 1.30158 1.40468 1.41044V23.554C0.826211 24.548 0.522101 25.6778 0.523442 26.8278V31.9165C0.523442 32.0253 0.566684 32.1297 0.643657 32.2067C0.720629 32.2837 0.825025 32.3269 0.93388 32.3269C1.04274 32.3269 1.14713 32.2837 1.2241 32.2067C1.30108 32.1297 1.34432 32.0253 1.34432 31.9165V26.8278C1.3456 25.3128 1.94801 23.8602 3.01931 22.7889C4.0906 21.7176 5.54322 21.1152 7.05826 21.1139H8.35155C11.6994 21.1139 12.6539 21.4463 14.5556 22.1086L17.0086 22.9609C17.0845 22.9874 17.1666 22.991 17.2446 22.9712C17.3225 22.9515 17.393 22.9093 17.4472 22.8498L22.1592 17.6759C22.3382 17.4843 22.5774 17.3597 22.837 17.323C23.0966 17.2862 23.3609 17.3395 23.5861 17.4739C23.7325 17.5574 23.8583 17.6726 23.9542 17.8112C24.0502 17.9498 24.1138 18.1081 24.1404 18.2745C24.1671 18.4409 24.156 18.6112 24.1082 18.7728C24.0603 18.9344 23.9767 19.0831 23.8637 19.2082L18.19 25.5346C18.0318 25.7129 17.8298 25.8468 17.6039 25.923C17.3781 25.9993 17.1362 26.0152 16.9023 25.9691L13.1947 24.7813C13.1332 24.7613 13.0678 24.7562 13.0039 24.7664C12.9401 24.7766 12.8795 24.8017 12.8272 24.8398C12.7749 24.8779 12.7324 24.9278 12.7031 24.9855C12.6738 25.0431 12.6586 25.1069 12.6587 25.1716V31.9165C12.6587 32.0253 12.702 32.1297 12.779 32.2067C12.8559 32.2837 12.9603 32.3269 13.0692 32.3269C13.178 32.3269 13.2824 32.2837 13.3594 32.2067C13.4364 32.1297 13.4796 32.0253 13.4796 31.9165V29.3589H37.59C37.6439 29.3589 37.6973 29.3483 37.7471 29.3276C37.7969 29.307 37.8422 29.2768 37.8803 29.2387C37.9184 29.2005 37.9486 29.1553 37.9692 29.1055C37.9899 29.0557 38.0005 29.0023 38.0005 28.9484V1.41044C38.0005 1.35654 37.9899 1.30317 37.9692 1.25337C37.9486 1.20357 37.9184 1.15833 37.8803 1.12021C37.8422 1.0821 37.7969 1.05187 37.7471 1.03124C37.6973 1.01062 37.6439 1 37.59 1ZM8.29038 20.2471C7.5582 20.2471 6.84246 20.03 6.23367 19.6232C5.62488 19.2165 5.15038 18.6383 4.87019 17.9618C4.58999 17.2854 4.51668 16.541 4.65952 15.8229C4.80237 15.1048 5.15495 14.4452 5.67268 13.9274C6.19041 13.4097 6.85005 13.0571 7.56816 12.9143C8.28628 12.7714 9.03063 12.8448 9.70708 13.125C10.3835 13.4052 10.9617 13.8796 11.3685 14.4884C11.7753 15.0972 11.9924 15.813 11.9924 16.5452C11.9924 17.0313 11.8966 17.5127 11.7106 17.9618C11.5245 18.411 11.2519 18.8191 10.9081 19.1629C10.5643 19.5066 10.1562 19.7793 9.70708 19.9653C9.25793 20.1514 8.77654 20.2471 8.29038 20.2471ZM37.182 28.5364H13.4844V25.7341L16.6939 26.761C17.074 26.844 17.4692 26.8249 17.8395 26.7058C18.2099 26.5866 18.5421 26.3716 18.8024 26.0826L24.4761 19.7562C24.6723 19.5378 24.8167 19.278 24.8985 18.9962C24.9804 18.7143 24.9976 18.4176 24.949 18.1281C24.9003 17.8386 24.7871 17.5638 24.6175 17.3242C24.448 17.0845 24.2267 16.8862 23.9699 16.7439C23.5842 16.5245 23.1355 16.4423 22.697 16.5107C22.2585 16.5791 21.8562 16.7941 21.5556 17.1206L17.0215 22.0949L14.826 21.3328C13.416 20.8419 12.4688 20.5119 10.6959 20.3711C11.5278 19.8487 12.1669 19.0694 12.5165 18.1514C12.8661 17.2333 12.907 16.2263 12.6332 15.2829C12.3594 14.3394 11.7857 13.5108 10.999 12.9226C10.2122 12.3343 9.25524 12.0183 8.27287 12.0224C7.29051 12.0266 6.33622 12.3506 5.55446 12.9455C4.77269 13.5404 4.206 14.3738 3.94014 15.3195C3.67429 16.2652 3.72375 17.2718 4.08103 18.1869C4.43832 19.102 5.08398 19.8758 5.9203 20.3912C4.49651 20.6441 3.19697 21.3625 2.22555 22.4337V1.82088H37.1796L37.182 28.5364Z"
                                fill="#5956E9"
                                stroke="#5956E9"
                              />
                              <path
                                d="M14.5354 6.11385H32.5279C32.6368 6.11385 32.7412 6.0706 32.8182 5.99363C32.8951 5.91666 32.9384 5.81226 32.9384 5.70341C32.9384 5.59455 32.8951 5.49016 32.8182 5.41318C32.7412 5.33621 32.6368 5.29297 32.5279 5.29297H14.5354C14.4266 5.29297 14.3222 5.33621 14.2452 5.41318C14.1682 5.49016 14.125 5.59455 14.125 5.70341C14.125 5.81226 14.1682 5.91666 14.2452 5.99363C14.3222 6.0706 14.4266 6.11385 14.5354 6.11385Z"
                                fill="#E541ED"
                                stroke="#E541ED"
                              />
                              <path
                                d="M32.5271 9.38672H29.0979C29.044 9.38672 28.9907 9.39734 28.9409 9.41796C28.8911 9.43859 28.8458 9.46882 28.8077 9.50693C28.7696 9.54505 28.7394 9.59029 28.7187 9.64009C28.6981 9.68989 28.6875 9.74326 28.6875 9.79716C28.6875 9.85106 28.6981 9.90443 28.7187 9.95422C28.7394 10.004 28.7696 10.0493 28.8077 10.0874C28.8458 10.1255 28.8911 10.1557 28.9409 10.1764C28.9907 10.197 29.044 10.2076 29.0979 10.2076H32.5271C32.581 10.2076 32.6344 10.197 32.6842 10.1764C32.734 10.1557 32.7792 10.1255 32.8173 10.0874C32.8554 10.0493 32.8857 10.004 32.9063 9.95422C32.9269 9.90443 32.9375 9.85106 32.9375 9.79716C32.9375 9.74326 32.9269 9.68989 32.9063 9.64009C32.8857 9.59029 32.8554 9.54505 32.8173 9.50693C32.7792 9.46882 32.734 9.43859 32.6842 9.41796C32.6344 9.39734 32.581 9.38672 32.5271 9.38672Z"
                                fill="#E541ED"
                                stroke="#E541ED"
                              />
                              <path
                                d="M14.5354 10.2076H24.959C25.0129 10.2076 25.0662 10.197 25.116 10.1764C25.1658 10.1557 25.2111 10.1255 25.2492 10.0874C25.2873 10.0493 25.3175 10.004 25.3382 9.95422C25.3588 9.90443 25.3694 9.85106 25.3694 9.79716C25.3694 9.74326 25.3588 9.68989 25.3382 9.64009C25.3175 9.59029 25.2873 9.54505 25.2492 9.50693C25.2111 9.46882 25.1658 9.43859 25.116 9.41796C25.0662 9.39734 25.0129 9.38672 24.959 9.38672H14.5354C14.4266 9.38672 14.3222 9.42996 14.2452 9.50693C14.1682 9.58391 14.125 9.6883 14.125 9.79716C14.125 9.90601 14.1682 10.0104 14.2452 10.0874C14.3222 10.1644 14.4266 10.2076 14.5354 10.2076Z"
                                fill="#E541ED"
                                stroke="#E541ED"
                              />
                              <path
                                d="M32.5344 13.4805H25.8089C25.7 13.4805 25.5956 13.5237 25.5187 13.6007C25.4417 13.6777 25.3984 13.7821 25.3984 13.8909C25.3984 13.9998 25.4417 14.1042 25.5187 14.1811C25.5956 14.2581 25.7 14.3013 25.8089 14.3013H32.5344C32.6433 14.3013 32.7477 14.2581 32.8247 14.1811C32.9016 14.1042 32.9449 13.9998 32.9449 13.8909C32.9449 13.7821 32.9016 13.6777 32.8247 13.6007C32.7477 13.5237 32.6433 13.4805 32.5344 13.4805Z"
                                fill="#E541ED"
                                stroke="#E541ED"
                              />
                              <path
                                d="M14.5354 14.3013H18.0612C18.17 14.3013 18.2744 14.2581 18.3514 14.1811C18.4284 14.1042 18.4716 13.9998 18.4716 13.8909C18.4716 13.7821 18.4284 13.6777 18.3514 13.6007C18.2744 13.5237 18.17 13.4805 18.0612 13.4805H14.5354C14.4266 13.4805 14.3222 13.5237 14.2452 13.6007C14.1682 13.6777 14.125 13.7821 14.125 13.8909C14.125 13.9998 14.1682 14.1042 14.2452 14.1811C14.3222 14.2581 14.4266 14.3013 14.5354 14.3013Z"
                                fill="#E541ED"
                                stroke="#E541ED"
                              />
                            </svg>
                          </span>
                          <span className="d-flex flex-column">
                            <span className="authentication-sidebar-title">
                              <b>100% Confidential</b>
                            </span>
                            <span className="authentication-sidebar-description">
                              Fully Confident
                            </span>
                          </span>
                        </span>
                      </span>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={8}>
                  <h1>Create Your Account</h1>
                  <form onSubmit={handleSubmit}>
                    <Row className="justify-content-center pt-5 text-start">
                      <Col xs={12} md={8}>
                        <Label>
                          <b>
                            <small className="fs-4">Email</small>
                          </b>
                        </Label>
                        <InputGroup className="overflow-hidden mb-3">
                          <Input
                            placeholder="Enter email"
                            className="fs-3 p-2"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="justify-content-center text-start">
                      <Col xs={12} md={8}>
                        <Label>
                          <b>
                            <small className="fs-4">Password</small>
                          </b>
                        </Label>
                        <InputGroup className="overflow-hidden mb-3">
                          <div className="password-wrapper">
                            <Input
                              placeholder="Create password"
                              className="fs-3 p-2"
                              name="password"
                              type={showPassword ? "text" : "password"}
                              value={formData.password}
                              onChange={handleChange}
                            />
                            <span
                              className="password-toggle-icon"
                              onClick={togglePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            >
                              {showPassword ? <FaEye /> : <FaEyeSlash />}
                            </span>
                          </div>
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="justify-content-center text-start">
                      <Col xs={12} md={8} className="mb-3">
                        <div className="d-sm-flex text-start">
                          <input
                            type="checkbox"
                            checked={showReferral}
                            onChange={() => setShowReferral(!showReferral)}
                            className="w-0"
                          />
                          <span className="ps-2 fs-5">Have a Referral?</span>
                        </div>
                      </Col>
                    </Row>

                    {showReferral && (
                      <Row className="justify-content-center text-start">
                        <Col xs={12} md={8}>
                          <Label>
                            <b>
                              <small className="fs-4">
                                Referral code (Optional){" "}
                              </small>
                            </b>
                          </Label>
                          <InputGroup className="mb-3">
                            <Input
                              type="text"
                              placeholder="Enter referral code"
                              className="fs-3 p-2"
                              name="referralCode"
                              value={formData.referralCode}
                              onChange={handleChange}
                            />
                          </InputGroup>
                        </Col>
                      </Row>
                    )}

                    {errorMessage && (
                      <Row className="justify-content-center">
                        <Col xs={12} md={8}>
                          <p className="error-msg">{errorMessage}</p>
                        </Col>
                      </Row>
                    )}

                    <Row className="justify-content-center">
                      <Col xs={12} md={8}>
                      <ReCAPTCHA
sitekey={process.env.REACT_APP_SITE_KEY}
 onChange={(value) => setCaptchaValue(value)}
/>
                      </Col>
                    </Row>
                    <Row className="justify-content-center py-3">
                      <Col xs={8}>
                        <Button
                          type="submit"
                          text="Register"
                          varient="linear-gradient-primary"
                          className="w-100"
                           disabled={!isFormValid || isSubmitting || !captchaValue}
                        >
                          Register
                        </Button>
                      </Col>
                    </Row>

                    <Row className="justify-content-center">
                      <Col xs={8}>
                        <span className="fs-4 text-center">
                          Already have an account?{" "}
                          <Link
                            to="/login"
                            className="text-decoration-none"
                            style={{ color: "#5956E9" }}
                          >
                            Login
                          </Link>
                        </span>
                      </Col>
                    </Row>

                    <Row className="justify-content-center">
                      <Col xs={12}>
                        <span className="text-center policy-text">
                          By Clicking Login, You agree our{" "}
                          <Link
                            to="/terms-and-conditions"
                            style={{ color: "black" }}
                          >
                            Terms & Conditions
                          </Link>
                          ,{" "}
                          <Link to="/refund-policy" style={{ color: "black" }}>
                            Refund Policy & Privacy Policy
                          </Link>
                        </span>
                      </Col>
                    </Row>
                  </form>
                </Col>
              </Row>
            </Container>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Register;
